import { getAntiForgeryToken } from '../antiforgery'

async function getCheckoutSetup(partnerName, paymentLinkGuid) {
    try {
        const response = await fetch(`checkout/getCheckoutSetup/${partnerName}/${paymentLinkGuid}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function getPaymentData(paymentLinkGuid, partnerName) {
    try {
        const response = await fetch(`checkout/${paymentLinkGuid}/${partnerName}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function settleQuotation(paymentLinkGuid, settlementRequest) {
    try {
        const response = await fetch(`checkout/${paymentLinkGuid}/settle`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify(settlementRequest)
        })

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function settleAutomaticValidation(paymentLinkGuid, quotationValues) {
    try {
        const response = await fetch(`checkout/${paymentLinkGuid}/UpsertAutomaticValidation`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify(quotationValues)
        })

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function checkValidationToken(paymentLinkGuid, partnerName) {
    try {
        const response = await fetch(`checkout/ValidationTokenStatus/${paymentLinkGuid}/${partnerName}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function validateToken(paymentLinkGuid, token) {
    try {
        const response = await fetch(`checkout/ValidationToken`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify({ paymentLinkGuid, token })
        })

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function reSendValidationToken(paymentLinkGuid, sendByEmail = true, sendByWhatsApp = false) {
    try {
        const response = await fetch(`checkout/reSendValidationToken`.toLocaleLowerCase(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': await getAntiForgeryToken(),
            },
            body: JSON.stringify({
                paymentLinkGuid: paymentLinkGuid,
                sendByEmail: sendByEmail,
                sendByWhatsApp: sendByWhatsApp
            })
        })

        return await response.json()
    } catch (error) {
        throw error
    }
}

async function checkLinkStatus(paymentLinkGuid, partnerName) {
    try {
        const response = await fetch(`checkout/CheckLinkStatus/${paymentLinkGuid}/${partnerName}`.toLocaleLowerCase())

        return await response.json()
    } catch (error) {
        throw error
    }
}



export {
    getCheckoutSetup,
    getPaymentData,
    settleQuotation,
    settleAutomaticValidation,
    checkValidationToken,
    validateToken,
    reSendValidationToken,
    checkLinkStatus
}
